import { FormEvent, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { PlayerBar } from "./PlayerBar";
import { Icon } from "./Icon";
const navigation = [
  { to: "/", label: "Explore", glyph: "explore" as const },
  { to: "/search", label: "Browse", glyph: "search" as const },
  { to: "/saved", label: "Saved", glyph: "save" as const },
];
export function Layout() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const submit = (e: FormEvent) => {
    e.preventDefault();
    navigate(
      `/search${query.trim() ? `?q=${encodeURIComponent(query.trim())}` : ""}`,
    );
  };
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="library-header">
        <Link className="library-brand" to="/">
          <img src="/brand/mark-reversed.svg" alt="" />
          <span>
            Eternally Blessed<small>THE LIBRARY</small>
          </span>
        </Link>
        <nav aria-label="Primary navigation">
          {navigation.map((n) => (
            <NavLink key={n.to} end={n.to === "/"} to={n.to}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <form role="search" onSubmit={submit}>
          <input
            aria-label="Search the library"
            placeholder="Search the library…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button aria-label="Search">
            <Icon name="search" />
          </button>
        </form>
      </header>
      <main id="main-content" className="main-content">
        <Outlet />
      </main>
      <footer className="library-footer">
        <div className="footer-signature">
          <img src="/brand/mark-reversed.svg" alt="" width="32" height="32" />
          <span>Eternally Blessed<small>Good words. For a full life.</small></span>
        </div>
        <nav aria-label="Footer navigation">
          <Link to="/search">Browse the library</Link>
          <a href="https://eternallyblessed-site.pages.dev/#app">The app</a>
          <a href="https://eternallyblessed-site.pages.dev">About us</a>
        </nav>
      </footer>
      <nav className="bottom-nav" aria-label="Mobile navigation">
        {navigation.map((n) => (
          <NavLink key={n.to} end={n.to === "/"} to={n.to}>
            <span aria-hidden="true">
              <Icon name={n.glyph} />
            </span>
            {n.label}
          </NavLink>
        ))}
      </nav>
      <PlayerBar />
    </div>
  );
}
